export const getToken = () => {
  return window.localStorage.getItem('canapay-merchant-token') || ''
}

export const setToken = (token) => {
  window.localStorage.setItem('canapay-merchant-token', token)
}
